<template>
  <v-card elevation="0">
    <v-card-text
      class="pt-5 pb-5"
      style="text-align: center"
    >
      <div>
        <v-icon
          class="lighten-1 mb-2"
          x-large
          circle
          dark
          :color="type"
        >
          {{ icon }}
        </v-icon>
      </div>
      <div class="title">
        {{ title }}
      </div>
      <div
        v-if="subtitle !== ''"
        class="subtitle-1 mb-3"
      >
        {{ subtitle }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
	export default {
		name: "InfoCard",
		props: {
			type: {
				type: String,
				default: 'success',
				validator: function (value) {
					// The value must match one of these strings
					return ['success', 'warning', 'error', 'info'].indexOf(value) !== -1
				}
			},
			title: {
				type: String,
				required: true
			},
			subtitle: {
				type: String,
				required: false,
				default: ''
			}
		},
		computed: {
			icon() {
				switch (this.type) {
					case 'success':
						return 'mdi-checkbox-marked-circle'
					case 'warning':
						return 'mdi-alert-circle'
					case 'error':
						return 'mdi-alert-circle'
          case 'networkError':
            return 'mdi-wifi-off'
					default:
						return 'mdi-information'
				}
			}
		},
		methods: {
			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>

</style>
